<div class="faq">
  <h2 class="faq__header"><abbr title="Frequently Asked Question">FAQ</abbr></h2>

  <div class="faq__question" [innerHTML]="block.data.question"></div>

  <div class="faq__answer" [innerHTML]="block.data.answer"></div>
</div>
